import { Alert, CircularProgress, FormControlLabel, Switch } from '@mui/material';
import { Radio, RadioGroup } from '@mui/material';
import { useProducts } from '../../hooks/useProducts';
import {
  setCombineIssues,
  setProduct,
  setValidateTimeNotes,
} from '../../redux/productSlice';
import { setFromRange, setToRange } from '../../redux/rangeSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { Product } from '../../utils/model';
import { productAll } from '../../hooks/products';

export const ProjectSelector: React.FC = () => {
  const dispatch = useAppDispatch();
  const { products, loading, error } = useProducts();
  const { product, combineIssues, validateTimeNotes } = useAppSelector((s) => s.product);
  const timeChanged = useAppSelector((s) => s.range.changed);

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={combineIssues}
            onChange={(e) => dispatch(setCombineIssues(e.target.checked))}
            color="secondary"
          />
        }
        label="Group By Issues"
      />
      <FormControlLabel
        control={
          <Switch
            checked={validateTimeNotes}
            onChange={(e) => dispatch(setValidateTimeNotes(e.target.checked))}
            color="secondary"
          />
        }
        label="Validate Time Notes"
      />
      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      <RadioGroup
        onChange={(e) => {
          const product: Product = JSON.parse(e.target.value);
          dispatch(setProduct(product));
          if (!timeChanged && product.name === productAll) {
            const today = new Date();
            const yesterday = new Date();
            yesterday.setDate(today.getDate() - 7);
            dispatch(setFromRange(yesterday));
            dispatch(setToRange(today));
          }
        }}
      >
        {products.map((p) => (
          <FormControlLabel
            checked={p.name === product?.name}
            key={p.name}
            value={JSON.stringify(p)}
            control={<Radio color={p.name === productAll ? 'warning' : 'primary'} />}
            label={p.name}
          />
        ))}
      </RadioGroup>
    </>
  );
};
